import classes from "./ActivityEditor.module.css"
import {ReactComponent as BACK} from "../../images/arrow-left-purple.svg"
import {ReactComponent as CHECK_MARKER} from "../../images/check_marker_purple.svg"
import YuJaButton from "../../components/standardization/YuJaButton";
import {
    ACTIONS_FOR, ACTIVITY_EDITOR_VIEW,
    ATTENDANCE,
    AUTO_SAVED_TEXT,
    BACK_TEXT,
    DISCARD_DRAFT_TEXT,
    DISCARD_QUESTION_BANK_TEXT, GO_TO_ACTIVITIES,
    GRADE_SCHEMA,
    HOME_PATH,
    IMPORT_QUESTION_BANK_TEXT,
    IMPORT_QUESTIONS_TEXT, MENU_LIST, MISSING_INFO,
    MODAL_SAVE_TEXT, POLL_SHARE_MODE, POLL_TEXT,
    POLL_TIME_LIMIT_MODAL_CANCEL,
    POLL_TITLE_LENGTH,
    POLL_TYPE,
    QUESTION_CARDS_CAN_NOT_ACCESS, QUESTION_CARDS_CAN_NOT_ACCESS_ATTENDANCE, REDIRECT_TO_ACTIVITIES_PAGE_CONFIRMATION,
    SAVING_TEXT
} from "../../utils/constants";
import React, { useState} from "react";
import Skeleton from "react-loading-skeleton";
import ImportQuestionModal from "../../components/modals/ImportQuestionModal";
import QuestionProfileModal from "../../components/modals/QuestionProfileModal";
import {useHistory, useLocation} from "react-router-dom";
import loadingJson from "../../animations/LoadingSpinner.json";
import Lottie from "react-lottie";
import {usePPTWebView} from "../../hooks/usePPTWebView";
import {generateUUID} from "../../utils/helpers";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {trimLineBreakerInQuestion, trimQuestion} from "../../utils/questionUtils";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import YuJaGeneralAlert from "../../components/modals/YuJaGeneralAlert";
import {YuJaKebabMenuNew} from "../../components/standardization/YuJaKebabMenuNew";



export default function ActivityEditorTitleContainer({
                                                         savedActivity={},
                                                         draftActivity = {},
                                                         setDraftActivity,
                                                         editorView,
                                                         setEditorView,
                                                         dataLoading,
                                                         userSettings,
                                                         setCurrQueDisplay,
                                                         isAutoSaving,
                                                         isSaving,
                                                         saveBtnDisabled,
                                                         handleSave,
                                                         setShowDeleteModal,
                                                         questionBankId,
                                                         generateTitle,
                                                         hasReleased=false,
                                                         validatePoll
}) {
    let location = useLocation();
    let history = useHistory();
    const {isPPTPage, goPollsPage} = usePPTWebView();
    const { isLMS, correctConfigurations, verifyConfiguration, verifyConfigurationBeforeSaving, isAPISyncOptionAvailable} = useSynLMSConfiguration();
    const {pollKey, gradeSchema, pollType, pollTitle="", questions=[]} = draftActivity;
    const [importCSVModalShow, setImportCSVModalShow] = useState(false);
    const [importingQuestionBankModal, setImportingQuestionBankModal] = useState(false);
    const [isEditBoxFocused, setIsEditBoxFocused] = useState(false);
    const [setTempPollKey, getTempPollKey] = useLocalStorageNew("activity_creation_temp_pollKey", "");
    const [setPreviousView, ] = useLocalStorageNew("previous_editor_view", "");
    const [alertShow, setAlertShow] = useState(false);

    let isReleasePage = location.pathname.startsWith("/poll/share");
    let isFromOneMoreStep = !!location?.state?.isFromOneMoreStep;

    const isShareAll = draftActivity.pollType === POLL_TYPE.ATTENDANCE
        || draftActivity.pollShareMode === POLL_SHARE_MODE.SHARE_ALL
        || draftActivity.pollShareMode === POLL_SHARE_MODE.SCHEDULE;



    const LottieOptions = {
        loop: true,
        autoplay: true,
        animationData: loadingJson,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        }
    };

    const onClickBack = () => {
        if (isPPTPage()) {
            goPollsPage();
        } else {
            if (history.length > 2) {
                if (isFromOneMoreStep) {
                    let pollToAdd = JSON.parse(JSON.stringify(savedActivity));
                    let questionsCopy = pollToAdd.questions;

                    if (pollToAdd.pollType !== POLL_TYPE.ATTENDANCE) {
                        questionsCopy = trimQuestion(questionsCopy, draftActivity.gradeSchema);
                    }
                    for (const que of questionsCopy) {
                        trimLineBreakerInQuestion(que);
                    }
                    pollToAdd.questions = questionsCopy;
                    pollToAdd = correctConfigurations(pollToAdd);
                    let validatePollError = validatePoll(pollToAdd, true);

                    if (!validatePollError) {
                        setAlertShow(true);
                        return;
                    }

                    let error = verifyConfiguration(pollToAdd);
                    if (!!error) {
                        setAlertShow(true);
                        return;
                    }

                    history.goBack();
                } else {
                    history.goBack();
                }

            } else {
                history.push(HOME_PATH);
            }
        }

    }


    const goBackAlertConfig = {
        title: MISSING_INFO,
        okText: GO_TO_ACTIVITIES,
        cancelText: POLL_TIME_LIMIT_MODAL_CANCEL,
        buttonWidth: 120,
        submit: async () => {
            setAlertShow(false);
            history.push(MENU_LIST.ACTIVITIES.path);
        },
        close: async () => {
            setAlertShow(false);
        },
    };




    const getPollKey = () => {
        let tempPollKey = !!pollKey ? pollKey : getTempPollKey();
        if (!tempPollKey) {
            tempPollKey = generateUUID();
            setTempPollKey(tempPollKey);
        }

        return tempPollKey;
    }

    const setQuestions = (questions) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        copy.questions = questions;
        let tempPollKey = getTempPollKey();
        if (!!tempPollKey) {
            if(!copy.pollKey) {
                copy.pollKey = tempPollKey;
            }
            setTempPollKey("");
        }
        setDraftActivity(copy);

    }

    const changePollKey = (pollKeyStr) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        copy.pollKey = pollKeyStr;
        setDraftActivity(copy);
    };

    const getSaveBtnTooltipText = () => {
        if (!draftActivity.questions
            || !draftActivity.questions.length
            || !draftActivity.questions.filter(q => !!q.questionType).length
        ) {
            if (!!questionBankId) {
                return "Add a question.";
            }


            return (isLMS()
                    ? "Select a grade option, fill out the required fields, and add a question."
                    : "Select a grade option and add a question."
            );
        }

        if (!!questionBankId) {
            return "";
        }


        if (pollType === POLL_TYPE.MERGED_POLL && !gradeSchema) {
            return (isLMS()
                    ? "Select a grade option, fill out the required fields, and add a question."
                    : "Select a grade option and add a question."
            );
        }


        let errorText = verifyConfigurationBeforeSaving(draftActivity);
        if (!!errorText) {
            return pollType === POLL_TYPE.ATTENDANCE
                ? (
                    isAPISyncOptionAvailable() ?
                        "Select a sync option, fill out the required fields, and add a question."
                        : "Select a sync option and add a question."
                )
                : (isLMS()
                    ? "Select a grade option, fill out the required fields, and add a question."
                    : "Select a grade option and add a question."
                );
        }



    }

    if (!!dataLoading) {
        return (
            <span
                className={classes.activityManageContainer}
                style={{display: "unset", border: "none", padding: 0,}}
            >
                <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={8}/>
            </span>
        );
    }


    let saveBtnTooltipText = getSaveBtnTooltipText();

    return (

        <>
            <YuJaGeneralAlert
                show={alertShow}
                setModalShow={setAlertShow}
                content={REDIRECT_TO_ACTIVITIES_PAGE_CONFIRMATION}
                config={goBackAlertConfig}
            />
            <div className={classes.activityManageContainer}>
                <ImportQuestionModal
                    setModalShow={setImportCSVModalShow}
                    show={importCSVModalShow}
                    questions={questions}
                    setQuestions={setQuestions}
                    userSettings={userSettings}
                    gradeSchema={!gradeSchema ? GRADE_SCHEMA.GRADED.key : gradeSchema}
                    setEditorView={setEditorView}
                />

                <QuestionProfileModal
                    show={importingQuestionBankModal}
                    setModalShow={setImportingQuestionBankModal}
                    setQuestions={setQuestions}
                    questions={questions}
                    setCurrQueDisplay={setCurrQueDisplay}
                    pollKey={pollKey}
                    changePollKey={changePollKey}
                    getPollKey={getPollKey}
                    userSettings={userSettings}
                    setEditorView={setEditorView}
                />

                {!isReleasePage &&
                    <span
                        tabIndex={0}
                        style={{cursor: "pointer", display: "flex", alignItems: "center"}}
                        onClick={onClickBack}
                    >
                        <BACK  style={{marginRight: 2}}/>
                        <span>{BACK_TEXT}</span>
                    </span>
                }

                <YuJaTooltip
                    disabled={!hasReleased}
                    placement={"bottom"}
                    text={pollType === POLL_TYPE.ATTENDANCE
                        ? "Editing Disabled: The title cannot be edited after an attendance is released."
                        : "Editing Disabled: The title cannot be edited after a poll is released."
                    }
                >
                    <div className={classes.activityTitleInputBox}>
                        <input
                            maxLength={POLL_TITLE_LENGTH}
                            disabled={hasReleased}
                            className={classes.activityTitleInput}
                            value={pollTitle}
                            onBlur={(e) => {
                                setIsEditBoxFocused(false);
                                if (!e.target.value && !!generateTitle) {
                                    let copy = JSON.parse(JSON.stringify(draftActivity));
                                    copy.pollTitle = generateTitle();
                                    setDraftActivity(copy);
                                }
                            }}
                            onFocus={(e) => {
                                setIsEditBoxFocused(true);
                                e.target.setSelectionRange(0, e.target.value.length);
                            }}
                            onChange={e => {
                                let copy = JSON.parse(JSON.stringify(draftActivity));
                                copy.pollTitle = e.target.value
                                setDraftActivity(copy);
                            }}
                        />


                        {isEditBoxFocused && pollTitle.length > 0 &&
                            <span className={classes.activityTitleInputRemaining}>
                                {POLL_TITLE_LENGTH - pollTitle.length}
                            </span>
                        }
                    </div>
                </YuJaTooltip>

                <span className={`${classes.autoSavingLabel} ${isAutoSaving === false ? classes.saved : ""}`}>
                    {isAutoSaving === false &&
                        <CHECK_MARKER className={classes.greenCheckMarker}/>
                    }
                    {isAutoSaving === true &&
                        <Lottie
                            options={LottieOptions}
                            width={20}
                            height={20}
                            style={{overflow: 'unset', cursor: "default", margin: 0}}
                            isClickToPauseDisabled={true}
                        />
                    }

                    {isAutoSaving === false &&
                        <span style={{whiteSpace: "nowrap"}}>{AUTO_SAVED_TEXT}</span>
                    }

                    {isAutoSaving === true &&
                        <span className={classes.autoSavingText}>{SAVING_TEXT}</span>
                    }
                </span>


                {!isReleasePage &&
                    <YuJaTooltip
                        tooltipStyle={{maxWidth: 300}}
                        disabled={!saveBtnTooltipText}
                        text={saveBtnTooltipText}
                        placement={"bottom"}
                    >
                        <YuJaButton
                            disabled={!!saveBtnTooltipText || isAutoSaving || isSaving}
                            style={{width: 90, height: 35,
                                display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15
                            }}
                            onClick={() => handleSave()}
                        >
                            {isSaving
                                ? <span className={classes.savingText}>{SAVING_TEXT}</span>
                                : MODAL_SAVE_TEXT
                            }
                        </YuJaButton>
                    </YuJaTooltip>
                }


            {/*    attendance release page or share all release page don't show kebab menu.*/}
                {!isReleasePage &&
                    <YuJaKebabMenuNew triggerAriaLabel={`${ACTIONS_FOR} ${pollType === POLL_TYPE.ATTENDANCE ? ATTENDANCE : POLL_TEXT}`}>
                        <YuJaKebabMenuNew.Menu>
                            {/*{pollType !== POLL_TYPE.ATTENDANCE && !!gradeSchema &&*/}
                            {/*    <YuJaKebabMenuNew.Item*/}
                            {/*        // onClick={() => setImportCSVModalShow(true)}*/}
                            {/*        onClick={() => {*/}
                            {/*            setPreviousView(editorView);*/}
                            {/*            setEditorView(ACTIVITY_EDITOR_VIEW.IMPORT_QUESTIONS);*/}
                            {/*        }}*/}
                            {/*    >*/}
                            {/*        {IMPORT_QUESTIONS_TEXT}*/}
                            {/*    </YuJaKebabMenuNew.Item>*/}
                            {/*}*/}
                            {/*{pollType !== POLL_TYPE.ATTENDANCE && !questionBankId && !!gradeSchema &&*/}
                            {/*    <YuJaKebabMenuNew.Item onClick={() => setImportingQuestionBankModal(true)}>*/}
                            {/*        {IMPORT_QUESTION_BANK_TEXT}*/}
                            {/*    </YuJaKebabMenuNew.Item>*/}
                            {/*}*/}
                            <YuJaKebabMenuNew.Item onClick={() => setShowDeleteModal(true)}>
                                {!!questionBankId ? DISCARD_QUESTION_BANK_TEXT : DISCARD_DRAFT_TEXT}
                            </YuJaKebabMenuNew.Item>


                        </YuJaKebabMenuNew.Menu>
                    </YuJaKebabMenuNew>
                }

            </div>
        </>
    );
}